import React, { useEffect, useState } from "react";
import {
  StyledColorCircle,
  StyledColorRadioButton,
  StyledColorRadioGroupWrapper,
  StyledColorRadioSpan,
  StyledColorRadioWrapper,
} from "../styles/styledComponents";
import Color from "../types/Color";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { useSelectedContextState } from "../context/selectedContext";

type ColorRadioGroupProps = {
  selected: (value: string) => any;
  radioValues: Color[];
  countryCode?: string;
};

const ColorRadioGroup = (props: ColorRadioGroupProps) => {
  const [selectedValue, setSelectedValue] = useState("");
  let { selected, radioValues, countryCode } = props;
  const [state] = useSelectedContextState();
  const { clearAll, clearChildrenStates } = state;

  useEffect(() => {
    if (clearAll || clearChildrenStates) {
      setSelectedValue("");
    }
  }, [clearAll, clearChildrenStates]);

  const onChange = (event: any) => {
    setSelectedValue(event.target.value);
    selected(event.target.value);
  };

  const _handleKeyDown = (e: any, id: any) => {
    if (e.key === "Enter") {
      setSelectedValue(id.toString());
      selected(id.toString());
    }
  };

  const specialColors = ['PL01', 'PL42', 'PL20', 'PL45', 'PL15'];

  let stockSuffix: string;
  switch (countryCode?.toLowerCase()) {
    case "no": {
      stockSuffix = "lagerført";
      break;
    }
    default: {
      stockSuffix = "lagerförd";
      break;
    }
  }

  const processColors = (colors: Color[]) => {
    return colors.map((color) => {
      if (color.name != null && specialColors.some(specialColor => color.name!.startsWith(specialColor))) {
        return { ...color, name: `${color.name} (${stockSuffix})` };
      }
      return color;
    });
  };

  const radioValuesProcessed = processColors(radioValues);
  
  return (
    <StyledColorRadioGroupWrapper role="radiogroup">
      {radioValuesProcessed.map((item, index) => (
        <StyledColorRadioWrapper
          key={item.id}
          role="radio"
          aria-labelledby={item.id + "txt"}
          aria-checked={selectedValue === item.id.toString()}
        >
          <StyledColorRadioButton
            aria-labelledby={item.id + "txt"}
            type="radio"
            name={item.code || ""}
            id={item.id.toString()}
            value={item.id}
            onChange={onChange}
            checked={selectedValue === item.id.toString()}
          />

          <StyledColorCircle
            style={{ background: item.htmlHex ? item.htmlHex : "white" }}
          >
            <FontAwesomeIcon
              icon={faCheck}
              color="white"
              size="lg"
              style={{
                position: "absolute",
                display:
                  selectedValue === item.id.toString() ? "block" : "none",
              }}
            />
          </StyledColorCircle>
          <StyledColorRadioSpan
            aria-label={item.code}
            onClick={() => {
              setSelectedValue(item.id.toString());
              selected(item.id.toString());
            }}
            tabIndex={0}
            onKeyDown={(e) => _handleKeyDown(e, item.id)}
            role="img"
          />

          <span
            id={item.id + "txt"}
            style={{
              marginTop: "20px",
              marginBottom: "20px",
              textAlign: "center",
            }}
          >
            {item.name ? item.name : ""}
          </span>
        </StyledColorRadioWrapper>
      ))}
    </StyledColorRadioGroupWrapper>
  );
};

export default ColorRadioGroup;
